import {
	TChangeModifierPositionSelectedItem,
	TTypeOfChangeModifierPositionModalWindow,
} from './changeModifierPositionContext';
import { IModifierPositionItem, IUpdateModifierPositions } from 'types';

export enum ChangeModifierPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_MODIFIER_GROUP = 'SET_ID_MODIFIER_GROUP',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	REORDER_ITEMS = 'REORDER_ITEMS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetIDCustomer {
	type: ChangeModifierPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: TChangeModifierPositionSelectedItem;
	};
}

interface ISetIDRestaurant {
	type: ChangeModifierPositionActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: TChangeModifierPositionSelectedItem;
	};
}

interface ISetIDModifierGroup {
	type: ChangeModifierPositionActionTypes.SET_ID_MODIFIER_GROUP;
	payload: {
		IDSelectedModifierGroup: TChangeModifierPositionSelectedItem;
	};
}

interface IResetSelectedControls {
	type: ChangeModifierPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeModifierPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IModifierPositionItem[];
	};
}

interface IReorderItems {
	type: ChangeModifierPositionActionTypes.REORDER_ITEMS;
	payload: {
		newOrder: IModifierPositionItem[];
	};
}

interface ISetDataForSubmit {
	type: ChangeModifierPositionActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateModifierPositions | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeModifierPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfChangeModifierPositionModalWindow;
	};
}

export type TChangeModifierPositionActions =
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDModifierGroup
	| IResetSelectedControls
	| ISetPositionsData
	| IReorderItems
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
